import * as React from "react"

import { cn } from "@/lib/utils"

interface ToggleProps extends Omit<React.ComponentProps<"input">, "type"> {
  title?: string;
}

const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  ({ className, title, ...props }, ref) => {
    return (
      <div className={cn("flex items-center gap-2 whitespace-nowrap", className)}>
        <label className="relative inline-flex h-5 w-9 cursor-pointer items-center">
          <input
            type="checkbox"
            className="peer sr-only"
            ref={ref}
            {...props}
          />
          <span className="absolute inset-0 rounded-full bg-gray-300 transition-colors peer-checked:bg-green-500 peer-focus-visible:ring-2 peer-focus-visible:ring-green-300" />
          <span className="absolute left-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform duration-200 peer-checked:translate-x-4" />
        </label>
        {title && <span >{title}</span>}
      </div>
    )
  }
)

Toggle.displayName = "Toggle"

export { Toggle }
